import { defineStore } from 'pinia'
import Api from '../api/Api'

export const usePodReviewerStore = defineStore('podReviewer', {
  state: () => ({
    usersWithAccessToPod: [],
    reviewers: [],
  }),
  getters: {
    getUsersWithAccessToPod: function (state) {
      return state.usersWithAccessToPod;
    },
    getReviewers: function (state) {
      return state.reviewers;
    }
  },
  actions: {
    refreshUsersWithAccessToPod: async function (podID) {
      const response = await Api.reviewer.getUsers(podID);
      this.usersWithAccessToPod = response.data;
      return response.data;
    },
    refreshReviewers: async function (podID) {
      const response = await Api.reviewer.getReviewers(podID);
      this.reviewers = response.data;
      return response.data;
    },
    inviteReviewers: async function(data) {
      const response = await Api.reviewer.inviteReviewers(data.podId, data.payload);
      this.reviewers =  response.data;
      return response.data;
    },
  },
});
